// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_resource.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AppResourceSearch } from "./app_resource";
import type { SearchAppResourceTypesRollupResponse } from "./app_resource";
import type { SearchAppResourceTypesRollupRequest } from "./app_resource";
import type { SearchAppResourceGrantsResponse } from "./app_resource";
import type { SearchAppResourceGrantsRequest } from "./app_resource";
import type { GetAppResourceGrantsSearchTermsResponse } from "./app_resource";
import type { GetAppResourceGrantsSearchTermsRequest } from "./app_resource";
import type { HighRiskRolesAndGrantsEntitlementsResponse } from "./app_resource";
import type { HighRiskRolesAndGrantsEntitlementsRequest } from "./app_resource";
import type { HighRiskRolesAndGrantsCountResponse } from "./app_resource";
import type { HighRiskRolesAndGrantsCountRequest } from "./app_resource";
import type { HighRiskRolesAndGrantsResponse } from "./app_resource";
import type { HighRiskRolesAndGrantsRequest } from "./app_resource";
import type { SearchAppResourcesWithDeactivatedOwnerResponse } from "./app_resource";
import type { SearchAppResourcesWithDeactivatedOwnerRequest } from "./app_resource";
import type { SearchAppResourceTypeTraitsRollupResponse } from "./app_resource";
import type { SearchAppResourceTypeTraitsRollupRequest } from "./app_resource";
import type { SearchAppResourceRollupResponse } from "./app_resource";
import type { SearchAppResourceRollupRequest } from "./app_resource";
import type { SearchAppResourcesResponse } from "./app_resource";
import type { SearchAppResourcesRequest } from "./app_resource";
import type { SearchAppResourceTypesResponse } from "./app_resource";
import type { SearchAppResourceTypesRequest } from "./app_resource";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppResourceService } from "./app_resource";
import type { DeleteManuallyManagedEntitlementResponse } from "./app_resource";
import type { DeleteManuallyManagedEntitlementRequest } from "./app_resource";
import type { DeleteManuallyManagedAppResourceResponse } from "./app_resource";
import type { DeleteManuallyManagedAppResourceRequest } from "./app_resource";
import type { CreateManuallyManagedAppResourceResponse } from "./app_resource";
import type { CreateManuallyManagedAppResourceRequest } from "./app_resource";
import type { CreateManuallyManagedResourceResponse } from "./app_resource";
import type { CreateManuallyManagedResourceRequest } from "./app_resource";
import type { AppResourceServiceUpdateResponse } from "./app_resource";
import type { AppResourceServiceUpdateRequest } from "./app_resource";
import type { AppResourceServiceListResponse } from "./app_resource";
import type { AppResourceServiceListRequest } from "./app_resource";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AppResourceServiceGetResponse } from "./app_resource";
import type { AppResourceServiceGetRequest } from "./app_resource";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceService
 */
export interface IAppResourceServiceClient {
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: AppResourceServiceGetRequest, options?: RpcOptions): UnaryCall<AppResourceServiceGetRequest, AppResourceServiceGetResponse>;
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AppResourceServiceListRequest, options?: RpcOptions): UnaryCall<AppResourceServiceListRequest, AppResourceServiceListResponse>;
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: AppResourceServiceUpdateRequest, options?: RpcOptions): UnaryCall<AppResourceServiceUpdateRequest, AppResourceServiceUpdateResponse>;
    /**
     * @generated from protobuf rpc: CreateManuallyManagedResource
     */
    createManuallyManagedResource(input: CreateManuallyManagedResourceRequest, options?: RpcOptions): UnaryCall<CreateManuallyManagedResourceRequest, CreateManuallyManagedResourceResponse>;
    /**
     * @generated from protobuf rpc: CreateManuallyManagedAppResource
     */
    createManuallyManagedAppResource(input: CreateManuallyManagedAppResourceRequest, options?: RpcOptions): UnaryCall<CreateManuallyManagedAppResourceRequest, CreateManuallyManagedAppResourceResponse>;
    /**
     * @generated from protobuf rpc: DeleteManuallyManagedAppResource
     */
    deleteManuallyManagedAppResource(input: DeleteManuallyManagedAppResourceRequest, options?: RpcOptions): UnaryCall<DeleteManuallyManagedAppResourceRequest, DeleteManuallyManagedAppResourceResponse>;
    /**
     * @generated from protobuf rpc: DeleteManuallyManagedEntitlement
     */
    deleteManuallyManagedEntitlement(input: DeleteManuallyManagedEntitlementRequest, options?: RpcOptions): UnaryCall<DeleteManuallyManagedEntitlementRequest, DeleteManuallyManagedEntitlementResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceService
 */
export class AppResourceServiceClient implements IAppResourceServiceClient, ServiceInfo {
    typeName = AppResourceService.typeName;
    methods = AppResourceService.methods;
    options = AppResourceService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: AppResourceServiceGetRequest, options?: RpcOptions): UnaryCall<AppResourceServiceGetRequest, AppResourceServiceGetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppResourceServiceGetRequest, AppResourceServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AppResourceServiceListRequest, options?: RpcOptions): UnaryCall<AppResourceServiceListRequest, AppResourceServiceListResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppResourceServiceListRequest, AppResourceServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: AppResourceServiceUpdateRequest, options?: RpcOptions): UnaryCall<AppResourceServiceUpdateRequest, AppResourceServiceUpdateResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppResourceServiceUpdateRequest, AppResourceServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateManuallyManagedResource
     */
    createManuallyManagedResource(input: CreateManuallyManagedResourceRequest, options?: RpcOptions): UnaryCall<CreateManuallyManagedResourceRequest, CreateManuallyManagedResourceResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateManuallyManagedResourceRequest, CreateManuallyManagedResourceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateManuallyManagedAppResource
     */
    createManuallyManagedAppResource(input: CreateManuallyManagedAppResourceRequest, options?: RpcOptions): UnaryCall<CreateManuallyManagedAppResourceRequest, CreateManuallyManagedAppResourceResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateManuallyManagedAppResourceRequest, CreateManuallyManagedAppResourceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteManuallyManagedAppResource
     */
    deleteManuallyManagedAppResource(input: DeleteManuallyManagedAppResourceRequest, options?: RpcOptions): UnaryCall<DeleteManuallyManagedAppResourceRequest, DeleteManuallyManagedAppResourceResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteManuallyManagedAppResourceRequest, DeleteManuallyManagedAppResourceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteManuallyManagedEntitlement
     */
    deleteManuallyManagedEntitlement(input: DeleteManuallyManagedEntitlementRequest, options?: RpcOptions): UnaryCall<DeleteManuallyManagedEntitlementRequest, DeleteManuallyManagedEntitlementResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteManuallyManagedEntitlementRequest, DeleteManuallyManagedEntitlementResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceSearch
 */
export interface IAppResourceSearchClient {
    /**
     * Search app resources based on filters specified in the request body.
     *
     * @generated from protobuf rpc: SearchAppResourceTypes
     */
    searchAppResourceTypes(input: SearchAppResourceTypesRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypesRequest, SearchAppResourceTypesResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResources
     */
    searchAppResources(input: SearchAppResourcesRequest, options?: RpcOptions): UnaryCall<SearchAppResourcesRequest, SearchAppResourcesResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourcesRollup
     */
    searchAppResourcesRollup(input: SearchAppResourceRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceRollupRequest, SearchAppResourceRollupResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourceTypeTraitsRollup
     */
    searchAppResourceTypeTraitsRollup(input: SearchAppResourceTypeTraitsRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypeTraitsRollupRequest, SearchAppResourceTypeTraitsRollupResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourcesWithDeactivatedOwner
     */
    searchAppResourcesWithDeactivatedOwner(input: SearchAppResourcesWithDeactivatedOwnerRequest, options?: RpcOptions): UnaryCall<SearchAppResourcesWithDeactivatedOwnerRequest, SearchAppResourcesWithDeactivatedOwnerResponse>;
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrants
     */
    highRiskRolesAndGrants(input: HighRiskRolesAndGrantsRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsRequest, HighRiskRolesAndGrantsResponse>;
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrantsCount
     */
    highRiskRolesAndGrantsCount(input: HighRiskRolesAndGrantsCountRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsCountRequest, HighRiskRolesAndGrantsCountResponse>;
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrantsEntitlements
     */
    highRiskRolesAndGrantsEntitlements(input: HighRiskRolesAndGrantsEntitlementsRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsEntitlementsRequest, HighRiskRolesAndGrantsEntitlementsResponse>;
    /**
     * @generated from protobuf rpc: GetAppResourceGrantsSearchTerms
     */
    getAppResourceGrantsSearchTerms(input: GetAppResourceGrantsSearchTermsRequest, options?: RpcOptions): UnaryCall<GetAppResourceGrantsSearchTermsRequest, GetAppResourceGrantsSearchTermsResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourceGrants
     */
    searchAppResourceGrants(input: SearchAppResourceGrantsRequest, options?: RpcOptions): UnaryCall<SearchAppResourceGrantsRequest, SearchAppResourceGrantsResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourceTypesRollup
     */
    searchAppResourceTypesRollup(input: SearchAppResourceTypesRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypesRollupRequest, SearchAppResourceTypesRollupResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceSearch
 */
export class AppResourceSearchClient implements IAppResourceSearchClient, ServiceInfo {
    typeName = AppResourceSearch.typeName;
    methods = AppResourceSearch.methods;
    options = AppResourceSearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Search app resources based on filters specified in the request body.
     *
     * @generated from protobuf rpc: SearchAppResourceTypes
     */
    searchAppResourceTypes(input: SearchAppResourceTypesRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypesRequest, SearchAppResourceTypesResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourceTypesRequest, SearchAppResourceTypesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResources
     */
    searchAppResources(input: SearchAppResourcesRequest, options?: RpcOptions): UnaryCall<SearchAppResourcesRequest, SearchAppResourcesResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourcesRequest, SearchAppResourcesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourcesRollup
     */
    searchAppResourcesRollup(input: SearchAppResourceRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceRollupRequest, SearchAppResourceRollupResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourceRollupRequest, SearchAppResourceRollupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourceTypeTraitsRollup
     */
    searchAppResourceTypeTraitsRollup(input: SearchAppResourceTypeTraitsRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypeTraitsRollupRequest, SearchAppResourceTypeTraitsRollupResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourceTypeTraitsRollupRequest, SearchAppResourceTypeTraitsRollupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourcesWithDeactivatedOwner
     */
    searchAppResourcesWithDeactivatedOwner(input: SearchAppResourcesWithDeactivatedOwnerRequest, options?: RpcOptions): UnaryCall<SearchAppResourcesWithDeactivatedOwnerRequest, SearchAppResourcesWithDeactivatedOwnerResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourcesWithDeactivatedOwnerRequest, SearchAppResourcesWithDeactivatedOwnerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrants
     */
    highRiskRolesAndGrants(input: HighRiskRolesAndGrantsRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsRequest, HighRiskRolesAndGrantsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<HighRiskRolesAndGrantsRequest, HighRiskRolesAndGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrantsCount
     */
    highRiskRolesAndGrantsCount(input: HighRiskRolesAndGrantsCountRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsCountRequest, HighRiskRolesAndGrantsCountResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<HighRiskRolesAndGrantsCountRequest, HighRiskRolesAndGrantsCountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrantsEntitlements
     */
    highRiskRolesAndGrantsEntitlements(input: HighRiskRolesAndGrantsEntitlementsRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsEntitlementsRequest, HighRiskRolesAndGrantsEntitlementsResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<HighRiskRolesAndGrantsEntitlementsRequest, HighRiskRolesAndGrantsEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAppResourceGrantsSearchTerms
     */
    getAppResourceGrantsSearchTerms(input: GetAppResourceGrantsSearchTermsRequest, options?: RpcOptions): UnaryCall<GetAppResourceGrantsSearchTermsRequest, GetAppResourceGrantsSearchTermsResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppResourceGrantsSearchTermsRequest, GetAppResourceGrantsSearchTermsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourceGrants
     */
    searchAppResourceGrants(input: SearchAppResourceGrantsRequest, options?: RpcOptions): UnaryCall<SearchAppResourceGrantsRequest, SearchAppResourceGrantsResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourceGrantsRequest, SearchAppResourceGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourceTypesRollup
     */
    searchAppResourceTypesRollup(input: SearchAppResourceTypesRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypesRollupRequest, SearchAppResourceTypesRollupResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourceTypesRollupRequest, SearchAppResourceTypesRollupResponse>("unary", this._transport, method, opt, input);
    }
}
